module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAsklEQVQ4T93TMQ4BQRQA0DeNWhyEaCQu4AAqBcIFnEApUUp0Ko7hBmpqh1BrRoZdkQ27W5tyfl7+n///hEgTc7T9PpfAJg9HtoFFiCwxwakEXwOrFI8c0Qr0Ej6ky8CsBD9DOcQgcKuNi/CZsE7mDDYwTBlj1p9KnME7pglm5b+eWpb5G6yFf8FKHFmji1Fe6uck3tXWaVhxhH+A026PK3a7+Ow+dmnO+a/qVO32R/yM/QMD10201Hv7NAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiugai.png
// module id = jVIz
// module chunks = 1